import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex/react';
import { api } from '@/lib/api';
import { Input } from '@/components/ui/input';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const OperatorsReportingPage = () => {
  const { t } = useTranslation('operator');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const summary = useQuery(api.app.duties.queries.reportingSummary as any, {
    from: from ? new Date(from).getTime() : undefined,
    to: to ? new Date(to).getTime() : undefined,
  });
  const byStatus = summary?.byStatus || {};
  const byState = summary?.byState || {};
  return (
    <div className='p-4 space-y-3'>
      <h1 className='text-2xl font-semibold'>{t('reporting.title')}</h1>
      <div className='grid grid-cols-2 gap-2 max-w-lg'>
        <div>
          <label className='block text-sm mb-1'>{t('reporting.from')}</label>
          <Input type='date' value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div>
          <label className='block text-sm mb-1'>{t('reporting.to')}</label>
          <Input type='date' value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
      </div>
      <div className='grid md:grid-cols-2 gap-4'>
        <section className='border rounded p-3'>
          <div className='font-medium mb-2'>{t('reporting.byStatus')}</div>
          <ul className='text-sm space-y-1'>
            {Object.keys(byStatus).map((k) => (
              <li key={k} className='flex justify-between'>
                <span>{k}</span>
                <span>{byStatus[k]}</span>
              </li>
            ))}
            {Object.keys(byStatus).length === 0 && <li className='opacity-70'>{t('reporting.noData')}</li>}
          </ul>
        </section>
        <section className='border rounded p-3'>
          <div className='font-medium mb-2'>{t('reporting.byState')}</div>
          <ul className='text-sm space-y-1'>
            {Object.keys(byState).map((k) => (
              <li key={k} className='flex justify-between'>
                <span>{k}</span>
                <span>{byState[k]}</span>
              </li>
            ))}
            {Object.keys(byState).length === 0 && <li className='opacity-70'>{t('reporting.noData')}</li>}
          </ul>
        </section>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/_protected/operators/reporting')({
  component: OperatorsReportingPage,
});
